import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const rejectRequest = createAsyncThunk("rejectRequest", async (data, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`approvals/reject-many`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RejectRequestSlice = createSlice({
	name: "RejectRequestSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetRequestRejectState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(rejectRequest.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(rejectRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(rejectRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetRequestRejectState } = RejectRequestSlice.actions;
export default RejectRequestSlice.reducer;
